module.exports = {"editableFields":["facility_manager","site_phone","site_email","staffing_model","site_type","size"]}


//////////////////
// WEBPACK FOOTER
// ./app/components/client-edit/facility-edit-form/facility-edit-editable-fields.json
// module id = 399
// module chunks = 0